import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, withKeys as _withKeys, normalizeStyle as _normalizeStyle, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "confirm-popup__title" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 1,
  class: "confirm-popup__question"
}
const _hoisted_4 = { class: "confirm-popup__highlight" }
const _hoisted_5 = { class: "confirm-popup__actions" }

import { ref, onMounted, onBeforeUnmount, computed, watch, nextTick } from 'vue';
import { i18n } from '@/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'ConfirmActionPopup',
  props: {
    title: {},
    question: {},
    highlight: {},
    questionHtml: {},
    position: {},
    confirmLabel: {},
    cancelLabel: {},
    width: { default: 240 }
  },
  emits: ["confirm", "cancel"],
  setup(__props: any, { emit: __emit }) {

const t = (key: string) => i18n.global.t(key);

const props = __props;

const emit = __emit;

const popupEl = ref<HTMLElement | null>(null);
const clampedPos = ref({ x: props.position.x, y: props.position.y });

function clampPosition() {
  const margin = 8;
  const popupWidth = popupEl.value?.offsetWidth ?? props.width;
  const popupHeight = popupEl.value?.offsetHeight ?? 120;
  const maxX = Math.max(margin, window.innerWidth - popupWidth - margin);
  const maxY = Math.max(margin, window.innerHeight - popupHeight - margin);
  clampedPos.value = {
    x: Math.min(Math.max(props.position.x, margin), maxX),
    y: Math.min(Math.max(props.position.y, margin), maxY),
  };
}

const positionStyle = computed(() => {
  const width = `${props.width}px`;
  return {
    left: clampedPos.value.x + 'px',
    top: clampedPos.value.y + 'px',
    width,
    minWidth: width,
    maxWidth: width,
  };
});

function onDocumentMousedown(e: MouseEvent) {
  if (popupEl.value && !popupEl.value.contains(e.target as Node)) {
    emit('cancel');
  }
}

onMounted(() => {
  nextTick(() => clampPosition());
  popupEl.value?.focus();
  document.addEventListener('mousedown', onDocumentMousedown, true);
  window.addEventListener('resize', clampPosition, true);
});

onBeforeUnmount(() => {
  document.removeEventListener('mousedown', onDocumentMousedown, true);
  window.removeEventListener('resize', clampPosition, true);
});

watch(
  () => props.position,
  () => nextTick(() => clampPosition()),
  { deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createElementVNode("div", {
      ref_key: "popupEl",
      ref: popupEl,
      class: "confirm-popup",
      style: _normalizeStyle(positionStyle.value),
      tabindex: "-1",
      onKeydown: [
        _cache[2] || (_cache[2] = _withKeys(($event: any) => (_ctx.$emit('cancel')), ["esc"])),
        _cache[3] || (_cache[3] = _withKeys(($event: any) => (_ctx.$emit('confirm')), ["enter"]))
      ]
    }, [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.title), 1),
      (_ctx.questionHtml)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: "confirm-popup__question",
            innerHTML: _ctx.questionHtml
          }, null, 8, _hoisted_2))
        : (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createTextVNode(_toDisplayString(_ctx.question), 1),
            (_ctx.highlight)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _cache[4] || (_cache[4] = _createTextVNode(" ")),
                  _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.highlight), 1)
                ], 64))
              : _createCommentVNode("", true)
          ])),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("button", {
          class: "confirm-popup__cancel",
          type: "button",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('cancel')))
        }, _toDisplayString(_ctx.cancelLabel ?? t('cancel_short')), 1),
        _createElementVNode("button", {
          class: "confirm-popup__confirm",
          type: "button",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('confirm')))
        }, _toDisplayString(_ctx.confirmLabel ?? t('confirm_short')), 1)
      ])
    ], 36)
  ]))
}
}

})